import * as React from 'react';
import { Create, CreateProps, NumberInput, SimpleForm, TextInput, minValue, required, SelectInput } from 'react-admin';
import { ELanguage } from "../enums";

export const OrganizationCoachNotificationCreate = (props: CreateProps): React.ReactElement => {
	return (
		<Create {...props}>
			<SimpleForm>
				<TextInput step={1} source="title" label="TITLE"/>
				<TextInput step={1} source="body" label="BODY" validate={[required()]}/>
				<NumberInput step={1} source="numberOfDaysSinceClientStart" label="NUMBER_OF_DAYS_SINCE_CLIENT_START" validate={[minValue(0), required()]}/>
				<SelectInput step={1} source="language" label="LANGUAGE" emptyValue={null} emptyText="" choices={[{id: null, name: ''} , ...Object.keys(ELanguage).map(key => ({
					id: ELanguage[key],
					name: ELanguage[key]
				}))]}/>
			</SimpleForm>
		</Create>
	);
};
